import * as React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { fetchSellersFilter } from '../../../actions/sellersActions';
import { DropDownArrow, customStyle } from "../../../template/CustomStyle";
import { setFiltroRebates, fetchRebates } from '../../../actions/rebatesActions';
import { filtroUnaSemana } from '../../../utilities/fechasFiltro';
const fechaFiltro = filtroUnaSemana();

class RebatesFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            skuSeller: this.props.filtro != "" ? this.props.filtro.skuSeller : "",
            skuMarket: this.props.filtro != "" ? this.props.filtro.skuMarket : "",
            seller: {
                label: this.props.filtro != "" ? this.props.filtro.idSellerLabel : "",
                value: this.props.filtro != "" ? this.props.filtro.idSeller : ""
            },
            estado: {
                label: this.props.filtro != "" ? this.props.filtro.estadoLabel : "TODOS",
                value: this.props.filtro != "" ? this.props.filtro.idTipoEstado : null
            },
            fechaDesde: this.props.filtro != "" ? this.props.filtro.fechaRebateDesde : fechaFiltro.desde,
            fechaHasta: this.props.filtro != "" ? this.props.filtro.fechaRebateHasta : fechaFiltro.hasta
        }
    }

    onSelectSearchInputSellers = (descripcion) => {
        this.props.fetchSellersFilter({ descripcion });
    }

    selectSearchHandler = (options, config) => {
        this.setState({ [config.name]: options });
    }

    onFilter = (event) => {
        event.preventDefault();

        this.props.setInitialPage();

        let params = {
            idTipoEstado: this.state.estado.value,
            estadoLabel: this.state.estado.label,
            idSeller: this.state.seller.value,
            idSellerLabel: this.state.seller.label,
            skuSeller: this.state.skuSeller,
            skuMarket: this.state.skuMarket,
            fechaDesde: this.state.fechaDesde,
            fechaHasta: this.state.fechaHasta,
            numeroPagina: 1,
            IdTipoUser: this.props.tipoUsuario,
            PageSize: 10
        }

        if (this.state.skuMarket != "") {
            params = this.buscarPorSKUMarketSOLO(params);
        }

        this.props.chargeFilterOptions(params);

        if (this.props.tipoUsuario !== 2 && this.props.tipoUsuario !== 1 ) {
            params.idSeller = this.props.idSeller;
        }

        this.props.setFiltroRebates(params);
        this.props.fetchRebates(params);
    }

    buscarPorSKUMarketSOLO = (params) => {
        if (params.skuMarket != null) {
            params = {
                idTipoEstado: this.state.estado.value,
                estadoLabel: this.state.estado.label,
                idSeller: this.state.seller.value,
                sellerLabel: this.state.seller.label,
                skuSeller: this.state.skuSeller,
                skuMarket: this.state.skuMarket,
                fechaRebateDesde: null,
                fechaRebateHasta: null,
                numeroPagina: 1,
                IdTipoUser: this.props.tipoUsuario
            }
        }
        return params;
    }

    onClearFilter = (event) => {
        event.preventDefault();
        this.props.setInitialPage();

        let params = {
            idSeller: this.props.tipoUsuario !== 2 && this.props.tipoUsuario !== 1 ? this.props.idSeller : null,
            fechaRebateHasta: fechaFiltro.hasta,
            fechaRebateDesde: fechaFiltro.desde,
            IdTipoUser: this.props.tipoUsuario,
            PageSize: 10

        }

        this.props.fetchRebates(params);
        this.props.chargeFilterOptions({ 
            idSeller: this.props.tipoUsuario !== 2 && this.props.tipoUsuario !== 1 ? this.props.idSeller : null,
            idTipoEstado: null,
            IdTipoUser: this.props.tipoUsuario
        })

        this.clearInputs();
    }

    clearInputs = () => {
        this.props.filtroRebates.numeroPagina = 1;
        this.setState({
            estado: { label: "TODOS", value: null },
            seller: { label: "", value: "" },
            skuSeller: "",
            skuMarket: "",
            fechaDesde: fechaFiltro.desde,
            fechaHasta: fechaFiltro.hasta,
            IdTipoUser: this.props.tipoUsuario
        })
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
        if (event.target.name == "fechaDesde") {
            this.setState({ fechaDesde: event.target.value })
        }
        if (event.target.name == "fechaHasta") {
            this.setState({ fechaHasta: event.target.value })
        }
    }

    mapSellers = () => {
        let opcionTodos = { value: "", label: "Todos" };
        this.props.sellers.unshift(opcionTodos);
    }


    render() {

        let listaSeller = [];
        if (this.props.sellers != undefined) {
            this.props.sellers.map((item) => {
                listaSeller.push({ label: item.label, value: item.value.toString() })
            })
        }

        const isModerador = this.props.tipoUsuario === 1 || this.props.tipoUsuario === 2;

        const optionsEstado = [
            { value: null, label: "TODOS" },
            { value: 3, label: "ACTIVOS" },
            { value: 1, label: "PENDIENTES" },
            { value: 2, label: "EN REVISIÓN" },
            { value: 4, label: "FINALIZADOS"},
            { value: 6, label: "RECHAZADOS"},
        ]

        const optionsEstadoSeller = [
            { value: null, label: "TODOS" },
            { value: 3, label: "ACTIVOS" },
            { value: 2, label: "EN REVISIÓN" },
            { value: 4, label: "FINALIZADOS"},
            { value: 6, label: "RECHAZADOS"},
        ]

        return (
            <div className="card card-body filter-card">
                <div className="row form-material justify-content-between">

                    <div className="col-lg-2" hidden={!isModerador}>
                        <label className="label-oscura">Seller</label>
                        <Select
                            name="seller"
                            value={this.state.seller}
                            options={listaSeller}
                            onChange={this.selectSearchHandler}
                            onMenuOpen={this.mapSellers}
                            onInputChange={this.onSelectSearchInputSellers}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            styles={customStyle}
                        />
                    </div>

                    <div className="col-lg-2">
                        <label className="label-oscura">Estado</label>
                        <Select
                            name="estado"
                            options={isModerador ? optionsEstado : optionsEstadoSeller}
                            onChange={this.selectSearchHandler}
                            value={this.state.estado}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            placeholder=""
                            styles={customStyle}
                        />
                    </div>

                    <div className="col-lg-2">
                        <label className="label-oscura">Sku Seller</label>
                        <input 
                            type="text" 
                            name="skuSeller" 
                            onChange={this.handleChange} 
                            value={this.state.skuSeller} 
                            className="form-control" 
                        />
                    </div>

                    <div className="col-lg-2">
                        <label className="label-oscura">Sku Market</label>
                        <input 
                            type="text" 
                            name="skuMarket" 
                            onChange={this.handleChange} 
                            value={this.state.skuMarket} 
                            className="form-control" 
                        />
                    </div>

                    <div 
                        className="col-lg-2" 
                        name="fechaDesde" 
                        onMouseEnter={this.handleChange}
                    >
                        <label className="label-oscura">Fecha desde</label>
                        <input 
                            type="date" 
                            name="fechaDesde" 
                            className="form-control" 
                            onChange={this.handleChange} 
                            value={this.state.fechaDesde} 
                        />
                    </div>

                    <div 
                        className="col-lg-2" 
                        name="fechaHasta" 
                        onMouseEnter={this.handleChange}
                    >
                        <label className="label-oscura">Fecha hasta</label>
                        <input 
                            type="date" 
                            name="fechaHasta" 
                            className="form-control" 
                            onChange={this.handleChange} 
                            value={this.state.fechaHasta}
                        />
                    </div>

                </div>

                <div className="row justify-content-center align-items-center p-10">
                    <div className="col-12 col-md-auto d-flex justify-content-center">
                        <button
                            className="btn d-inline btn-sm btn-grey"
                            onClick={this.onFilter} 
                            disabled={this.props.loadingRebates}
                        >
                            Buscar
                        </button>
                        <button className="btn btn-sm btn-grey d-inline ms-2" onClick={this.onClearFilter}>
                            Limpiar
                        </button>
                    </div>
                </div>
                
            </div>
        )
    }
}


const mapStateToProps = state => ({
  rebates: state.rebates.rebates,
  loadingRebates: state.publicaciones.loadingRebates,
  tipoUsuario: state.general.tipoUsuario,
  sellers: state.sellers.filteredSellers,
  idSeller: state.general.idSeller,
  filtroRebates: state.rebates.filtro,
});

export default connect(mapStateToProps, { 
  fetchRebates, 
  fetchSellersFilter, 
  setFiltroRebates 
}) (RebatesFilter);